import { queryOptions } from '@tanstack/react-query';
import { ClientResponseModelMock } from 'modules/clients/types/client.interfaces';
import { mockClientResponse } from 'stores/client-mock-data';

export const clientDataKeys = {
  base: () => ['client-data'] as const,
  getClients: () => ['client-data'] as const
};

export const getClientData = (clientId: number) => {
  return queryOptions({
    queryKey: [...clientDataKeys.getClients(), clientId],
    queryFn: async (): Promise<ClientResponseModelMock | undefined> => {
      return mockClientResponse.find((client) => client.clientID === clientId);
    },
    enabled: !!clientId
  });
};
